import React from "react";

const BeSeenLogo = () => {
  return (
    <div
      style={{
        display: "flex",
        paddingBottom:"24px",
      }}
    >
      <span
        style={{
          fontWeight: "bold",
          fontFamily: "'Abril Fatface', serif",
          marginBottom: "5px",
          color: "#184353",
          fontSize: "40px",
          textAlign: "center",
          width: "100%",
          display: "block",
        }}
      >
        Be:Seen
      </span>
    </div>
  );
};

export default BeSeenLogo;
